'use client'

import { fetchAndActivate, getValue } from 'firebase/remote-config'
import { useEffect, useState } from 'react'

import { remoteConfig } from '@/utils/analytics/firebaseConfig'

let hasFetched = false

export const useFeatureFlags = () => {
  const [ready, setReady] = useState(hasFetched)

  useEffect(() => {
    const config = remoteConfig
    if (!config || hasFetched) return

    const init = async () => {
      try {
        await fetchAndActivate(config)
      } catch (err) {
        console.error('Remote config fetch failed', err)
      } finally {
        hasFetched = true
        setReady(true)
      }
    }

    init()
  }, [])

  const isEnabled = (key: string, fallback = false) => {
    if (!remoteConfig) return fallback
    return getValue(remoteConfig, key).asBoolean()
  }

  const getValueForKey = (key: string, fallback = '') => {
    if (!remoteConfig) return fallback
    return getValue(remoteConfig, key).asString()
  }

  return {
    ready,
    isEnabled,
    getValueForKey,
  }
}
